/**
 * Morrow — verification fixture for the CompanionProfile boundary.
 *
 * NOT a shipping companion. Exists only so we can flip the resolver
 * (`?companion=morrow`) and confirm that shared SONMI code contains no
 * hardcoded Toto naming or Toto-specific assets. Morrow deliberately
 * offers a different identity across every field the shell reads so any
 * missed hardcode is instantly visible.
 */
const morrowProfile = {
  id: "morrow",
  name: "Morrow",
  displayName: "Morrow",
  pronouns: null,

  wordmark: "MORROW",
  productWordmark: "MORROW",
  productTagline: "a SONMI reference companion",
  chatCta: "Ask Morrow",
  chatAriaLabel: "Chat with Morrow",
  chatAssistantName: "Morrow",
  searchPlaceholder: "Search MORROW…",
  guidedTourLabel: "Take a tour",

  iconMarkKey: null,        // no icon glyph — proves the shell doesn't force one
  occupantKey: null,        // empty vessel is Morrow's presence
  avatarKey: null,          // no avatar assets
  toneKey: "neutral-professional",

  terminology: {
    guest: "client",
    boutique: "office",
    team_member: "colleague",
  },

  capabilities: {
    animatedPresence: false,
    boutiqueTinting: false,
    iconMark: false,
    hasAssets: false,
  },
};

export default morrowProfile;
